export interface Document {
  type: DocumentType;
  name: string;
  metadata: DocumentMetaData;
  url?: string;
  file?: any;
}

export interface DocumentMetaData {
  lastModifiedDate?: Date;
  name?: string;
  mimeType?: string;
  horizons?: {
    dossierId?: string;
    reference?: string;
    damageId?: string;
    documentId?: string;
  };
}
export enum DocumentTypeEnum {
  DOCUMENT = 'DOCUMENT',
  INSURANCE_CARD = 'INSURANCE_CARD',
  VEHICLE_REGISTRATION = 'VEHICLE_REGISTRATION',
  '3_4' = '3_4',
  CLOSER_LOOK = 'CLOSER_LOOK',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
}

export type DocumentType = `${DocumentTypeEnum}`;

export const supportedFileTypes = [
  'image/png',
  'image/jpeg',
  'application/pdf',
];
export const withPreviewFileTypes = ['image/png', 'image/jpeg'];
export const compressableFileTypes = ['image/png', 'image/jpeg'];
export const withNativeBrowserPreview = ['application/pdf'];
